module.exports = __webpack_public_path__ + "static/media/locallighting.76e195f5.frag";